<template>
  <section class="content">
   <div id="overlay"  v-if="loading">
     <div class="spinner"></div>
     <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="purchaseSalesDate">Damage Date</label>
                <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="damageNo">Damage No</label>
                <InputText id="damageNo" disabled v-model="damageNo"/>
              </div>
             <div class="p-field p-col-12 p-md-2">
               <label for="referenceNumber" >Ref No</label>
               <InputText id="refNO"  v-model="referenceNumber"/>
             </div>

              <div class="p-field p-col-12 p-md-2">
               <label for="warehouse">Store</label>
                <Dropdown
                 v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                 v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>
              <wearhouseDialog class="p-mt-5" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <!-- <div class="form-group container">
              <div class="col-md-3">
               <label for="party">Order From</label>
                <Dropdown
                  v-model="accountMasterId"
                  :options="supplierAndCustomerList"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Vendor"
                  :showClear="true"
                />
                 <customerDialog style="float: left;margin: -12.5% 0% 0% 93%;" v-tooltip.top="'Add Customer'"/>
              </div>
              <div class="col-md-3 " style="margin-top: 2.5em;" v-if="accountMasterId.id>0">
               <label for="panNo" >Cur. Bal:</label>
               <b  style="margin-left:20px;color:red" v-if="accountMasterId.closingBalance>0">{{(accountMasterId.closingBalance) + 'Cr'}}</b>
               <b v-else style="margin-left:20px;color:green;">{{(accountMasterId.closingBalance * (-1)).toFixed(2) + 'Dr'}}</b>
             </div>
              <div class="col-md-2 address" style="margin-top: 2.5em;">
                <label for="address" v-if="accountMasterId.id>0">Contact Name:</label>
                <b>{{accountMasterId.contactName}}</b>
              </div>
              <div class="col-md-2 address" style="margin-top: 2.5em;" v-if="accountMasterId.id>0">
                <label for="panNo"  v-if="accountMasterId.id>0">Pan No:</label>
                <b>{{accountMasterId.panNo!==''?accountMasterId.panNo:'N/A'}}</b>
              </div>
            </div> -->

            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                <label for="item" >Item<b style="color:red;">*</b></label>
                <!-- <Dropdown
                  v-model="items"
                  :options="itemMasterListByItemType"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Item"
                /> -->
                <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                 field="name" ref="itm" >
                  <template #item="slotProps">
                    <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
                  </template>
                 </AutoComplete>
              </div>
              <!-- <itemDialog style="margin-top:1.3em;margin-right: -10em;" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/> -->

              <div class="p-field p-col-12 p-md-1 align-self-end">
            <itemDialog class="p-mt-5" v-tooltip.top="'Add Item'"
                      @set_data_item="set_data_item"/>
          </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="quantity">Sales Qty</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="quantity" v-model="quantity" /> -->
              <InputNumber  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="quantity"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
                <InputText v-model="items.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="rate">Rate</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="rate" v-model="rate" /> -->
             <InputNumber  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="rate"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="total" >Total</label>
                <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" v-model="total"/> -->
              <InputNumber disabled id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="total"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button p-component addNewBtn btn-btm-0" :label="!editDTO?'Add':'Update'"
                @click.prevent="addItemToDTO"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button v-if="editDTO" class="p-button-raised p-button-danger" id="action"
                @click.prevent="itemDTOreset" label="Cancel"/>
              </div>
              <!-- <div class="col-sm-2">

              </div> -->
            </div>

            <div style="display:none">{{totalAmount}}{{findRate}}{{setRateFromItem}}</div>
               <div class="p-field p-col-12 p-md-1" v-if="items.closingStock >=0">
               <label  for="avlQty">Cur. Stock: </label>
                <span>{{items.closingStock}}</span>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div>
            <div class="scrollable">
            <table class="table table-bordered ">
              <thead >
                <tr>
                  <th scope="col">SN</th>
                  <th scope="col">Item Name</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <tr>
                  <td>{{index+1}}</td>
                  <td>{{item.itemMaster.name}}</td>
                  <td>{{item.quantity}}</td>
                  <td>{{item.rate}}</td>
                  <td>{{item.rate * item.quantity}} </td>
                  <td>
                    <Button class="p-button-raised p-button-success" @click="editItemFromDTO(item, index)" icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger" v-if="editDTO" @click="deleteItemFromDTO(item, index)"
                    disabled icon="pi pi-trash"/>
                    <Button class="p-button-raised p-button-danger" v-else-if="!editDTO" @click="deleteItemFromDTO(item, index)"
                    icon="pi pi-trash"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
               <b style="margin-left: 15em;">Total:</b>
             </div>
             <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 16em;">{{totalQty}}</b>
             </div>
             <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 38em;">{{subTotal}}</b>
             </div>
             </div>
          <hr>
         </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <Textarea rows="6" v-model="narration"/>
          </div>

             <div class="p-field p-col-12 p-md-3">
            <Button id="imageUpload" @click.prevent="showItemUpload" class="p-button-raised"
                    label="Upload Image"/>
          </div>

           <div class="p-field p-col-12 p-md-2">
              <label >Link</label>
            <InputText v-model="linkUrl"></InputText>
          </div>

        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-success" icon="pi pi-save"
             @click.prevent="saveSalesOrder" :label="!editing?'Save':'Update'"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-warning" @click="reset" v-if="damage==undefined" label="Reset" icon="pi pi-refresh"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-danger" v-if="damage != undefined" @click="goBack()" label="Cancel"/>
            <Button class="p-button-raised p-button-danger" v-else @click="goBack()" label="Cancel" disabled/>
          </div>

          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-secondary" v-if="saved" icon="pi pi-print" label="Print"/>
            <Button class="p-button-raised p-button-secondary" v-else icon="pi pi-print" label="Print" disabled/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" v-if="saved" label="Generate PDF" icon="pi pi-download"/>
            <Button class="p-button-raised p-button-secondary" v-else label="Generate PDF" icon="pi pi-download" disabled/>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import customerDialog from '../accountDialog/CustomerAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Carousel from 'primevue/carousel'
export default {
  name: 'damage',
  props: ['damage'],
  data() {
    return {
      warehouseId: '',
      accountMasterId: '',
      items: '',
      referenceNumber: '',
      englishDateEnabled: true,
      quantity: 0,
      orderMessage: '',
      rate: 0,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editDTO: false,
      editing: false,
      inventoryOutheaderId: null,
      index: null,
      damageNo: null,
      loading: false,
      id: null,
      totalQty: 0,
      total: 0,
      filteredItems: null,
      saved: false,
      narration: '',
      setWarehouseData: false,
      url: [],
      deletedImage: [],
      imageList: [],
      linkUrl: '',
      showItemUploadDialog: false
    }
  },
  computed: {
    totalBillAmount() {
      return parseFloat(this.quantity) * parseFloat(this.rate)
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      if (this.total > 0 && this.quantity > 0) {
        let rate = 0
        rate = parseFloat(this.total) / parseFloat(this.quantity)
        if (isNaN(rate)) {
          rate = 0
        }
        this.rate = rate
        return rate
      }
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.salesRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty = parseFloat(this.totalQty) + parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return subTotal.toFixed(4)
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.itemMasterListByItemTypes()
    this.maxSalesOrderNo()
    if (this.damage !== undefined) {
      this.editSales()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.damage === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemType')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      }
    },
    async maxSalesOrderNo() {
      let response = await this.$store.dispatch('maxDamageNo')
      if (this.damage === undefined) {
        this.damageNo = response.data.data
        this.orderMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.damageNo = this.damage.damageNo
        this.orderMessage = this.damage.remarks
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
    //   if (this.accountMasterId === '') {
    //     this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
    //     return
    //   }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one Item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.items = data.itemMaster
      this.index = index
      this.total = (parseFloat(this.rate) * parseFloat(this.quantity)).toFixed(2)
      this.rate = data.rate
      this.quantity = data.quantity
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async saveSalesOrder() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      let response = ''
      let damage = {
        damageNo: this.damageNo,
        warehouseId: this.warehouseId.id,
        accountMasterId: this.accountMasterId.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        remarks: this.narration,
        id: this.inventoryOutheaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
        linkUrl: this.linkUrl
      }
      // console.log
      // // debugger
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
    //   if (this.accountMasterId === '') {
    //     this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
    //     return
    //   }
      if (damage.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please add at least one item!', life: 10000})
        return
      }
      if (this.damage === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addDamage', damage)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateDamage', damage)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.setWarehouse()
        await this.maxSalesOrderNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    set_data_warehouse(data) {
      this.warehouseId = data
    },
    set_data_item(data) {
      this.items = data
    },
    editSales() {
      this.editing = true
      // this.purchaseSalesDate = this.salesOrder.purchaseSalesDate
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.damage.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.damage.purchaseSalesDate
      }
      this.referenceNumber = this.damage.referenceNumber
      this.narration = this.damage.remarks
      this.warehouseId = this.damage.warehouse
      this.accountMasterId = this.damage.accountMaster
      this.inventoryOutheaderId = this.damage.id
      this.inventoryInOutDetailList = this.damage.inventoryInOutDetailList
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    setNepaliDate() {
      if (this.damage === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        let fileExtension = f.name.split('.').pop()
        console.log(fileExtension)
        if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'JPG') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 10000})
          return
        }
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
          // console.log(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseId = ''
      this.accountMasterId = ''
      this.referenceNumber = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.inventoryInOutDetailList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.damage.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    cancelImageUpload() {
      this.url = []
      this.showItemUploadDialog = false
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    customerDialog,
    wearhouseDialog,
    itemDialog,
    Button,
    Textarea,
    InputText,
    Carousel
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// damage.vue?4d3957e0